/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.Header');

  if (!header) return;

  let lastScroll = 0;

  window.addEventListener('scroll', function () {
    const current = window.scrollY;

    if (current > 1) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }

    lastScroll = current;
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.AnnouncementBar__Slide');
  if (slides.length <= 1) return;

  let index = 0;
  slides[0].classList.add('is-active');

  setInterval(() => {
    slides[index].classList.remove('is-active');
    index = (index + 1) % slides.length;
    slides[index].classList.add('is-active');
  }, 4000); // 4 sec
});

